import React, { useState, useEffect } from 'react';
import Info from '../../info';
import { showManageInvitationsModal } from 'actions/modal';
import { displayGlobalMessage } from 'actions/globalMessage';
import { sendReminderByUserId, getUserInvitationsByUserId } from 'actions/user';
import { useTimeout } from 'businessLogic/helperHooks';

const RightPanel = (props) => {
  const [sendingReminder, setSendingReminder] = useState(false);
  const [isReminderBtnDisabled, setIsReminderBtnDisabled] = useState(false);
  const [delay, setDelay] = useState(null);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [reminderButtonClass, setReminderButtonClass] = useState('');

  const closeModal = () => {
    props.dispatch(showManageInvitationsModal(false));
  };

  useTimeout(
    () => {
      setIsReminderBtnDisabled(false);
      // Destroy the timer when finish
      setIsTimerRunning(false);
    },
    isTimerRunning ? delay : null
  );

  useEffect(() => {
    let reminderButtonClass = !isReminderBtnDisabled
      ? props.intendedDeletedInvitatioans.length === 0
        ? ''
        : 'disabled '
      : 'disabled ';
    setReminderButtonClass(reminderButtonClass);
  }, [props.intendedDeletedInvitatioans, isReminderBtnDisabled]);

  const sendReminder = () => {
    // To avoid repetitive clicking the button
    if (props.intendedDeletedInvitatioans.length > 0 || sendingReminder || isReminderBtnDisabled) return;
    setSendingReminder(true);
    // Start the timer
    setIsTimerRunning(true);
    setIsReminderBtnDisabled(true);

    let cb = (successful) => {
      setSendingReminder(false);
      if (!!successful) {
        setDelay(10000);
        props.dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ManageInvitations.ReminderSentSuccessfulMessage.replace(
              '##invitedUserEmailAddress##',
              props.selectedUser.email
            ),
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        props.dispatch(getUserInvitationsByUserId(props.selectedUser.personId));
      }
    };
    props.dispatch(sendReminderByUserId(props.selectedUser.personId, cb));
  };

  let saveClasses =
    'ui labeled icon button icon left-text color-button color-button-hover color-white max-width mrbm mrlnull mrbnull';
  let cancelClasses =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull';

  return (
    <div>
      <div className="mrtxxs mrbl max-width">
        <button
          type="button"
          onClick={props.handleSave}
          className={(props.intendedDeletedInvitatioans.length > 0 ? '' : 'disabled ') + saveClasses}
        >
          {APP.LANGUAGE.ManageInvitations.RemoveRoles}
          <i className="trash icon" />
        </button>
        <button
          type="button"
          className={(sendingReminder ? 'loading ' : '') + reminderButtonClass + saveClasses}
          onClick={sendReminder}
        >
          {APP.LANGUAGE.ManageInvitations.SendReminder}
          <i className="send icon" />
        </button>

        <button type="button" onClick={closeModal} className={cancelClasses}>
          <i className="remove icon" />
          {APP.LANGUAGE.Close}
        </button>
      </div>
      <Info
        paragraphs={[
          APP.LANGUAGE.ManageInvitations.InfoText1,
          APP.LANGUAGE.ManageInvitations.InfoText2,
          APP.LANGUAGE.ManageInvitations.InfoText3,
        ]}
      />
    </div>
  );
};
export default RightPanel;
